import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

function load (componentFileName: string) {
  return () => import(`@/views/${componentFileName}.vue`)
}

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "root",
    component: load('Home')
  },
  {
    path: "/home/:lang?",
    name: "home",
    component: load('Home')
  },
  {
    path: "/frame/:lang?",
    name: "painting",
    component: load('Painting')
  },
  {
    path: '*',
    name: 'rest',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
